module.exports = __webpack_public_path__ + "media/site/images/voicetalents-slider/voicetalents_screens-11-ef9e05f430c84e2288b2d2323e4569ba.jpg";